import gql from "graphql-tag";

export default gql`
  query getDownloadUrlsByToken($token_type: String!, $token: String!, $filePaths: [String!]!) {
    getDownloadUrlsByToken(token_type: $token_type, token: $token, filePaths: $filePaths)
  }
`;
